export default "__VITE_ASSET__G0TNvro3__"